import { render } from "./UpdateCorporatePlanComponent.vue?vue&type=template&id=9f9654ee"
import script from "./UpdateCorporatePlanComponent.vue?vue&type=script&lang=js"
export * from "./UpdateCorporatePlanComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__